
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ErrorHandler', function ($log, $state, $timeout, Parse, Alerts) {
		return function (error, state) {

			// Handle case when "error" is undefined
			if (!error) {
				if (state) {
					$log.error('undefined error on state', state);
				} else {
					$log.error('undefined error');
				}
				Alerts.add({
					type: 'danger',
					msg: 'Something went wrong! We\'re letting our engineers know.',
					timeout: 5000
				});
				return;
			}

			// $log.error('State', state);
			// $log.error('Error', error);


			// Handle invalid Parse session token
			if (error.code === Parse.Error.INVALID_SESSION_TOKEN) {
				/*
					Problem: The users session has expired or become invalid
					Solution: Log out the user and return them to the login page
				*/


				// Log the user out and return to the login page
				Parse.User.logOut();
				$timeout(() => {
					// Send alert using "sessionExpired"
					$state.go('login', {}, { sessionExpired: true });
				}, 100);
				

			} else if (error.code === Parse.Error.OBJECT_NOT_FOUND) {

				if (state.name === 'product') {

					// Add alert to what happened to global alerts
					Alerts.add({
						type: 'danger',
						msg: 'Product not found'
					});

					// Return to the products page
					$state.go('products');

				} else if (state.name === 'account.document-request-review') {

					// Add alert to what happened to global alerts
					Alerts.add({
						type: 'danger',
						msg: 'Document request not found'
					});

					// Return to the document requests page
					$state.go('account.document-requests', {}, {
						// Set "notify" false so the global alert sticks routing to a child state
						notify: false
					});

				} else {

					// Return to the account dashboard
					$state.go('account.dashboard');
					
				}

			} else if (error.code === 100) {

				// The UI is unable to connect to the parse API

				// TODO: handle appropriatly

			}

		}
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/errorhandler.service.js